import lazyWithRetry from 'tools/lazyWithRetry';

const BillableDashboardPage = lazyWithRetry(() => import(
	/* webpackChunkName: "billableDashboardPage" */
	'../../pages/Billable/BillableDashboardPage/BillableDashboardPage'));

const BillableCreditToValidateListPage = lazyWithRetry(() => import(
	/* webpackChunkName: "billableCreditToValidateListPage" */
	'../../pages/Billable/BillableCreditToValidateListPage'));

export default [
	{
		component: BillableDashboardPage,
		path: '/sub_partitions/:subPartitionId/billables/:billableId',
	},
	{
		component: BillableCreditToValidateListPage,
		path: '/sub_partitions/:subPartitionId/to_edit_billables',
	},
];
